<template>
  <v-container fluid py-0 px-0>
    <u-i-toolbar-admin :title="'Invoice #' + (invoice.id || '')" icon="request_quote" size-icon="24"/>

    <v-layout v-if="invoice.id" row wrap>
      <v-flex pl-2 xs12 sm12 md12>
        <v-layout justify-start fill-height row>
          <v-flex xs12 sm12 md12>
            <u-i-list-info :data="invoice" :displayFields="invoiceFields"/>
          </v-flex>
        </v-layout>
      </v-flex>

      <v-flex xs12 pt-4>
        <u-i-list-title>
          Transaction History
        </u-i-list-title>
        <table-admin
          :headers="transactionsHeaders"
          :items="invoice.invoice_transactions"
          :loading="false"
        />
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>

import InvoiceService from '@/services/Admin/Invoices';
import {common} from '@/mixins/common';
import UIToolbarAdmin from '@/components/UI/ToolbarAdmin';
import UIListInfo from '@/components/UI/ListInfo';
import TableAdmin from '@/components/UI/TableAdmin';
import UIListTitle from '@/components/UI/ListTitle';

export default {
  name: 'AdminViewHistoryInvoice',
  metaInfo() {
    const titleTemplate = `%s - Admin | ${this.titlePage}`
    return {titleTemplate}
  },
  props: {
    id: {
      required: true,
      type: [String, Number],
    },
  },
  components: {
    UIToolbarAdmin,
    UIListInfo,
    TableAdmin,
    UIListTitle
  },
  mixins: [common],
  data() {
    return {
      invoice: {
        id: 0,
        is_paid: null,
        type: '',
        payment_method: null,
        human_friendly_date_paid: '',
        amount_total: 0,
        invoice_transactions: [],
        user: {
          id: 0,
          username: 0,
        },
        order: {
          id: 0,
          currency: {
            id: 0,
            symbol: '',
          },
        },
        group: {
          id: 0,
          orders: [],
        },
      },
      transactionsHeaders: [
        {text: 'Date', value: 'created', sortable: true, class: 'th-blue text-xs-center', classTagTd: 'text-xs-center px-1'},
        {text: 'User', value: 'user.username', sortable: true, class: 'th-blue text-xs-center', classTagTd: 'text-xs-center px-1'},
        {text: 'Total Amount', value: 'amount_total', sortable: false, class: 'th-blue text-xs-center', classTagTd: 'text-xs-center px-1'},
        {text: 'Is Paid', value: 'is_paid', sortable: true, class: 'th-blue text-xs-center', classTagTd: 'text-xs-center px-1', library: 'admin/libraries/yesNo/getById',},
        {text: 'Is Void', value: 'is_void', sortable: true, class: 'th-blue text-xs-center', classTagTd: 'text-xs-center px-1', library: 'admin/libraries/yesNo/getById',},
        {text: 'Is Deleted', value: 'is_deleted', sortable: true, class: 'th-blue text-xs-center', classTagTd: 'text-xs-center px-1', library: 'admin/libraries/yesNo/getById',},
        {text: 'Reason', value: 'reason', sortable: true, class: 'th-blue', classTagTd: 'px-1'},
      ],
    }
  },
  created() {
    this.loadLibraries();
  },
  mounted() {
    this.getViewHistory();
  },
  computed: {
    titlePage() {
      return 'Invoice #' + this.id;
    },
    invoiceFields() {
      return [
        {label: 'Invoice Information', field: '', prefix: '', block: true},
        {label: 'Invoice ID', field: 'id', prefix: '#', block: false},
        {label: 'Total Amount', field: 'amount_total', prefix: this.currencySymbol, block: false},
        {label: 'Type', field: 'type', prefix: '', block: false},
        {label: 'Payment Method', field: 'payment_method', prefix: '', block: false},
        {label: 'Is Paid', field: 'is_paid', prefix: '', block: false, library: 'admin/libraries/yesNo/getById',},
        {label: 'Date Paid', field: 'human_friendly_date_paid', prefix: '', block: false},
        {label: 'Username', field: 'user.username', prefix: '', block: false},
      ]
    },
    currencySymbol() {
      if (
          (this.invoice.order === undefined && this.invoice.group === undefined) ||
          ((!this.invoice.order || this.invoice.order.id === 0) && this.invoice.group === null)
      ) {
        return '$'
      } else {
        if (this.invoice.order) {
          return this.invoice.order.currency.symbol;
        } else {
          return this.invoice.group.orders[0].currency.symbol;
        }
      }
    },
    isMerchandise() {
      return this.invoice.type === this.$invoiceType.PayForBase;
    }
  },
  methods: {
    loadLibraries() {
      Promise.all([
        this.$store.dispatch('admin/libraries/yesNo/fetch')
      ]).finally(() => this.isLoadingLibraries = true);
    },
    getViewHistory() {
      this.$store.commit('setLoading', true);
      InvoiceService.getViewHistory(this.id)
          .then(response => {
            if (response.status === this.$response.Ok) {
              this.invoice = response.data.data;
            }
          })
          .catch(error => {
            this.$store.dispatch('setError', error.response.message);
          })
          .finally(() => this.$store.commit('setLoading', false));
    },
  }
}
</script>

<style scoped lang="stylus">
.fields-view-order
  height 18px
  width 142px
  color #252A30
  font-family Roboto
  font-size 14px
  font-weight 500
  line-height 18px

.fields-view-order-details
  color #252A30
  font-family Roboto
  font-size 14px
  line-height 18px
</style>